import { __assign, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Card } from '../Card';
import { Layout } from '../Layout';
import { classNames } from '../utils/stringUtils';
import styles from './Panel.module.css';
import tokens from '@metro-ui/tokens/css/custom-properties.module.css';
export var Panel = React.forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, children = _a.children, _c = _a.padding, padding = _c === void 0 ? 'none' : _c, htmlAttributes = __rest(_a, ["className", "children", "padding"]);
    var panelClassNames = classNames((_b = {},
        _b[tokens.mdsComp] = true,
        _b[styles.mdsCompPanel] = true,
        _b[className !== null && className !== void 0 ? className : ''] = true,
        _b));
    return (React.createElement(Card, __assign({}, htmlAttributes, { className: panelClassNames, padding: padding, ref: ref }), children));
});
Panel.propTypes = __assign(__assign({}, Card.propTypes), { className: PropTypes.string, children: PropTypes.node });
var PanelComponent = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["className", "children"]);
    var panelComponentClassNames = classNames((_b = {},
        _b[tokens.mdsComp] = true,
        _b[styles.mdsCompPanelSection] = true,
        _b[className !== null && className !== void 0 ? className : ''] = true,
        _b));
    return (React.createElement(Layout, __assign({}, htmlAttributes, { className: panelComponentClassNames }), children));
};
export var WrappedPanelComponent = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["className", "children"]);
    var wrappedPanelComponentClassNames = classNames((_b = {},
        _b[tokens.mdsComp] = true,
        _b[styles.mdsCompWrappedCompPanelComponent] = true,
        _b[className !== null && className !== void 0 ? className : ''] = true,
        _b));
    return (React.createElement(PanelComponent, __assign({}, htmlAttributes, { className: wrappedPanelComponentClassNames }), children));
};
export var PanelHeader = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["className", "children"]);
    var mdsPanelHeaderClassNames = classNames((_b = {},
        _b[tokens.mdsComp] = true,
        _b[styles.mdsCompPanelHeader] = true,
        _b[className !== null && className !== void 0 ? className : ''] = true,
        _b));
    return (React.createElement(WrappedPanelComponent, __assign({}, htmlAttributes, { className: mdsPanelHeaderClassNames }), children));
};
PanelHeader.propTypes = __assign(__assign({}, Layout.propTypes), { className: PropTypes.string, children: PropTypes.node });
export var PanelFooter = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["className", "children"]);
    var mdsPanelFooterClassNames = classNames((_b = {},
        _b[tokens.mdsComp] = true,
        _b[styles.mdsCompPanelFooter] = true,
        _b[className !== null && className !== void 0 ? className : ''] = true,
        _b));
    return (React.createElement(WrappedPanelComponent, __assign({}, htmlAttributes, { className: mdsPanelFooterClassNames }), children));
};
PanelFooter.propTypes = __assign(__assign({}, Layout.propTypes), { className: PropTypes.string, children: PropTypes.node });
export var PanelContent = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["className", "children"]);
    var mdsPanelContentClassNames = classNames((_b = {},
        _b[tokens.mdsComp] = true,
        _b[className !== null && className !== void 0 ? className : ''] = true,
        _b));
    return (React.createElement(PanelComponent, __assign({}, htmlAttributes, { className: mdsPanelContentClassNames }), children));
};
PanelContent.propTypes = __assign(__assign({}, Layout.propTypes), { className: PropTypes.string, children: PropTypes.node });
//# sourceMappingURL=Panel.js.map